import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=5c04cbff&scoped=true&"
import script from "./Destinations.vue?vue&type=script&lang=js&"
export * from "./Destinations.vue?vue&type=script&lang=js&"
import style1 from "./Destinations.vue?vue&type=style&index=1&id=5c04cbff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04cbff",
  null
  
)

export default component.exports